module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_check-8fcc718304160e3635677e7a8e8393e0.svg";